import { render, staticRenderFns } from "./Romanza_dessertItem.vue?vue&type=template&id=4c6a8dc2&scoped=true"
import script from "./Romanza_dessertItem.vue?vue&type=script&lang=ts"
export * from "./Romanza_dessertItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6a8dc2",
  null
  
)

export default component.exports